import styled from "styled-components";

import { useSidebarBreakpoint } from "../../../windowBreakpoints";

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 0px;
  min-width: 0px;
  height: 100%;
  background-color: #F0F0F0;
  display:none;
`;

export const StyledLeaderboardsList = styled.div`
  display: flex;
  flex-direction: column;
  overflow: scroll;
`;

export const StyledLeaderboardItem = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  padding-left: 15px;
  width: 100%;
  height: 42px;
  font-weight: 600;
  color: ${props => props.isSelected ? "#fff" : "rgba(0,0,0,.6)"};
  background-color: ${props => props.isSelected ? "#265287" : "transparent"};
  overflow: hidden;
  cursor: pointer;
  transition: color .2s ease-out;
  @media (min-width: ${useSidebarBreakpoint}px) {
    & button {
      width: 0;
      min-width: 0;
    }
  }
  :hover {
    color: ${props => props.isSelected ? "#fff" : "rgba(0,0,0,.9)"};
    & button {
      width: 40px;
      min-width: 40px;
    }
  }
`;

export const StyledEditLeaderboardBtn = styled.button<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-left: auto;
  width: 40px;
  height: 100%;
  min-width: 40px;
  color: ${props => props.isSelected ? "#fff" : "rgba(0,0,0,.6)"};
  background-color: transparent;
  border: none;
  border-left: ${props => props.isSelected ? "1px solid rgba(255,255,255,.2)" : "none"};
  outline: none;
  transition: all .2s ease-out, width .1s ease-out, min-width .1s ease-out;
  cursor: pointer;
  :hover {
    color: ${props => props.isSelected ? "#fff" : "rgba(0,0,0,.9)"};
  }
  @media (max-width: ${useSidebarBreakpoint}px) {
    width: 40px;
    min-width: 40px;
  }
`;

export const StyledAddLeaderboardBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: none;
  margin-top: auto;
  height: 38px;
  color: rgba(0,0,0,.7);
  background-color: #F2F2F2;
  box-shadow: 0px -1px 6px rgba(0, 0, 0, 0.1);
  outline: none;
  cursor: pointer;
  transition: all .2s ease-out;
  :hover {
    color: rgba(0, 0, 0, 1);
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
  }
`;
